import { render, staticRenderFns } from "./export-details.vue?vue&type=template&id=c68d7ca2&scoped=true"
import script from "./export-details.vue?vue&type=script&lang=js"
export * from "./export-details.vue?vue&type=script&lang=js"
import style0 from "./export-details.vue?vue&type=style&index=0&id=c68d7ca2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68d7ca2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c68d7ca2')) {
      api.createRecord('c68d7ca2', component.options)
    } else {
      api.reload('c68d7ca2', component.options)
    }
    module.hot.accept("./export-details.vue?vue&type=template&id=c68d7ca2&scoped=true", function () {
      api.rerender('c68d7ca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/EDI/export-details.vue"
export default component.exports